import { withErrorBoundary } from 'react-error-boundary';
import { useIsMobile } from 'hooks/responsive';
import CheckboxFilter from './CheckboxFilter';
import MultiSelectFilter from './MultiSelectFilter';
import QuickViewFilter from './QuickViewFilter';
import type { SelectorButtonProps } from './types';

type SelectMethod = 'checkbox' | 'select' | 'quickview' | undefined;

function getSelectMethod(optionsAmount: number): SelectMethod {
    const dropdownMaxItems = 14;
    const isMobile = useIsMobile();

    switch (true) {
        case optionsAmount === 0:
            return undefined;
        case optionsAmount === 1:
            return 'checkbox';
        case isMobile:
            return 'quickview';
        case optionsAmount <= dropdownMaxItems:
            return 'select';
        case optionsAmount > dropdownMaxItems:
            return 'quickview';
        default:
            return undefined;
    }
}

function SelectorButton(props: SelectorButtonProps) {
    const { selectOptions, selectType, toggleOptionToFilterArray } = props;
    const selectMethod = getSelectMethod(selectOptions.length);
    if (!selectMethod) return;

    switch (selectMethod) {
        case 'checkbox':
            return (
                <CheckboxFilter
                    selectOption={selectOptions[0]}
                    selectType={selectType}
                    toggleOptionToFilterArray={toggleOptionToFilterArray}
                />
            );
        case 'select':
            return <MultiSelectFilter {...props} />;
        case 'quickview':
            return <QuickViewFilter {...props} />;
        default:
            return null;
    }
}

export default withErrorBoundary(SelectorButton, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
